import config from '../config/app'
import axios from 'axios'

const VERSION = '/v2'
const PATH = 'team'

const teamAccountsAPI = {
  getTeamAccountData (type, params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = ''
    if (type === 'summary') {
      url = config.server + VERSION + '/' + PATH + '/team-account-summaries?' + stringParams
    } else {
      url = config.server + VERSION + '/' + PATH + '/team-account-details?' + stringParams
    }
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        if (type === 'list') {
          resolve(response)
        } else {
          resolve(response.data)
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  getTeamAccountList (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + VERSION + '/' + PATH + '/team-account-details?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  geEmployeeAccounts (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/company-team-accounts', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  issueEmployeeAccounts (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/issue-employee-accounts', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  removeEmployeeAccounts (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/remove-employee-accounts', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  purchaseAccount (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/purchase-account', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  UpdatePurchaseAccount (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/update-purchase-account', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  PurchaseAccountPayments (params) {
    let stringParams = Object.keys(params).filter((i) => {
      return params[i] !== '' && params[i] !== null
    }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => {
        return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m])
      }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = ''
    url = config.server + VERSION + '/' + PATH + '/purchase-account-payment-details?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEmployeeDeleteCountOnDowngrade (params, companyId) {
    if (companyId !== undefined && companyId !== null) {
      params['company_id'] = companyId
    }
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + '/' + PATH + '/downgrade-delete-employee-popup', params).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadAccountPurchasePaymentReceipt (paymentId) {
    let url = config.server + VERSION + '/' + PATH + '/purchase-account-payment-receipt'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = '?payment_id=' + paymentId
    return fetch(url + params, {headers}).then(response => response.blob())
  }
}

export default teamAccountsAPI



// WEBPACK FOOTER //
// ./src/api/teamAccounts.js